import { lighten, styled } from '@mui/material/styles';
import ListItem, { type ListItemProps } from '@mui/material/ListItem';

interface HoverListItemProps extends ListItemProps {
  forceHover?: boolean;
  padded?: boolean;
}

const HoverListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'forceHover' && prop !== 'padded',
})<HoverListItemProps>(({ forceHover, padded, theme }) => ({
  '&.MuiListItem-root': {
    padding: padded ? '4px 0 4px 16px' : 0,
  },
  '&.subheader': {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    borderTop: `0.5px solid ${theme.palette.divider}`,
    '& .MuiListItemButton-root': {
      backgroundColor: theme.palette.background.header,
      '&:hover': {
        backgroundColor: lighten(theme.palette.background.header, 0.08),
      },
      // Selected folder headers need a visible tint; the forced header bg otherwise
      // overrides MUI's default `Mui-selected` background.
      '&.Mui-selected': {
        backgroundColor: lighten(theme.palette.background.header, 0.06),
        '&:hover': {
          backgroundColor: lighten(theme.palette.background.header, 0.06),
        },
      },
    },
  },
  '& .MuiListItemButton-root': {
    paddingRight: 0,
    position: 'relative',
  },
  '& .MuiListItemSecondaryAction-root': {
    position: 'absolute',
    right: 8,
    '& button': {
      opacity: forceHover ? 1 : 0,
      transition: [
        theme.transitions.create('opacity', {
          easing: theme.transitions.easing.easeIn,
          duration: theme.transitions.duration.enteringScreen,
        }),
      ],
    },
  },
  '&:hover .MuiListItemSecondaryAction-root button': {
    opacity: 1,
    transition: [
      theme.transitions.create('opacity', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.leavingScreen,
      }),
    ],
  },
  '&:hover .MuiListItemButton-root.Mui-disabled': {
    backgroundColor: 'initial',
  },
  '& .MuiIconButton-root': {
    fontSize: '1.2rem',
  },
  '& .MuiListItemText-root': {
    maskImage: `linear-gradient(90deg, rgba(0,0,0,1) calc(100% - 30px), rgba(0,0,0,0) 100%)`,
  },
}));

export default HoverListItem;
